export default {
  // 2-7 教室/課程/課表管理
  GET_CLASSROOM_DATA(state, res) {
    let data = JSON.parse(JSON.stringify(res.data));
    data.forEach((e, index) => {
      e.index = index + 1;
    });
    state.classroom = data;
    state.classroom_list = state.classroom.slice(0, 10);
  },

  FOR_SCHEDULE_USE(state, res) {
    let data = JSON.parse(JSON.stringify(res.data.course));
    data.forEach((e, index) => {
      e.index = index + 1;
      e.description2 = e.description;
    });
    state.all_course = data;
    state.all_courselist = state.all_course.slice(0, 10);
    state.all_classroom = res.data.rooms;
  },
  GET_SUPPLIER_DATA(state, res) {
    state.vendor_list = res.data;
  },
  GET_COURSE_DATA(state, res) {
    let data = JSON.parse(JSON.stringify(res.data.course));
    data.forEach((e, index) => {
      e.index = index + 1;
      e.courseInfo = `${e.schedule_No}/${e.course_Name}/${e.course_Description}(${e.course_No})`;
      if (e.repeat_Code == "WEEKLY") {
        e.courseType =
          e.day_In_Week == "1"
            ? "每週(星期一)"
            : e.day_In_Week == "2"
            ? "每週(星期二)"
            : e.day_In_Week == "3"
            ? "每週(星期三)"
            : e.day_In_Week == "4"
            ? "每週(星期四)"
            : e.day_In_Week == "5"
            ? "每週(星期五)"
            : e.day_In_Week == "6"
            ? "每週(星期六)"
            : "每週(星期日)";
      } else {
        let wkday = new Date(e.available_Begin_Date).getDay();
        e.courseType =
          wkday == "1"
            ? "當天(星期一)"
            : wkday == "2"
            ? "當天(星期二)"
            : wkday == "3"
            ? "當天(星期三)"
            : wkday == "4"
            ? "當天(星期四)"
            : wkday == "5"
            ? "當天(星期五)"
            : wkday == "6"
            ? "當天(星期六)"
            : "當天(星期日)";
      }
      e.courseRoom = `${e.room_Description}/${e.min_Audience}人`;
      e.courseTime = `${e.available_Begin_Date}~${e.available_End_Date} (${e.begin_Time}~${e.end_Time})`;
    });
    state.course = data;
    state.course_list = state.course.slice(0, 10);
  },
  GET_STATUS_DATA(state, res) {
    const data = JSON.parse(JSON.stringify(res.detail));
    data.forEach((e, index) => {
      e.index = index + 1;
      //let wkday = new Date(e.available_Begin_Date).getDay();
      let wkday = e.day_In_Week;
      let suffix =
        wkday == "1"
          ? "(星期一)"
          : wkday == "2"
          ? "(星期二)"
          : wkday == "3"
          ? "(星期三)"
          : wkday == "4"
          ? "(星期四)"
          : wkday == "5"
          ? "(星期五)"
          : wkday == "6"
          ? "(星期六)"
          : "(星期日)";
      e.class_date = e.class_Date + suffix;
      e.editSelect = "";
    });
    state.lecture = data;
    state.lecture_list = state.lecture.slice(0, 10);
  },

  // 2-10 異動申請審核
  GET_CARDID_DATA(state, res) {
    const data = JSON.parse(JSON.stringify(res.data));
    data.forEach((e, index) => {
      e.index = index + 1;
      e.applyInfo = `${e.apply_Date}/${e.s_Name}`;
      e.staffInfo = `${e.id}/${e.sex}/${e.p_Name}`;
      e.issue_Card = e.approve_Status;
    });
    state.cardId = data;
    state.cardId_list = state.cardId.slice(0, 10);
  },

  // 2-11 黑名單
  GET_BLACKLIST_DATA(state, res) {
    const data = JSON.parse(JSON.stringify(res.data));
    data.forEach((e, index) => {
      e.index = index + 1;
    });
    state.blacklist = data;
    state.blacklist_list = state.blacklist.slice(0, 10);
  },
};
